import { render, staticRenderFns } from "./Ranking.vue?vue&type=template&id=1013d8d6&scoped=true&lang=pug&"
import script from "./Ranking.vue?vue&type=script&lang=ts&"
export * from "./Ranking.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1013d8d6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/arc-one/_www/millsta-ready/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1013d8d6')) {
      api.createRecord('1013d8d6', component.options)
    } else {
      api.reload('1013d8d6', component.options)
    }
    module.hot.accept("./Ranking.vue?vue&type=template&id=1013d8d6&scoped=true&lang=pug&", function () {
      api.rerender('1013d8d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/templates/Ranking.vue"
export default component.exports